import React from "react";
import { Button, TextField } from "@mui/material";
import styles from "./concern.module.css";
import { useState } from "react";
import { useEffect } from "react";

import MicIcon from "@mui/icons-material/Mic";
import MicOffIcon from "@mui/icons-material/MicOff";
import { token_api } from "../../Utils/Network";

const SpeechRecognition =
  window.SpeechRecognition || window.webkitSpeechRecognition;
const mic = new SpeechRecognition();

mic.continuous = true;
mic.interimResults = true;
mic.lang = "en-US";

const CustomConcern = ({ userId, id, area_concern, ...props }) => {
  // const { transcript, resetTranscript } = useSpeechRecognition();
  // useEffect(() => {
  //   setStudentConcern(transcript);
  // }, [transcript]);
  const [isListening, setIsListening] = useState(false);
  const [note, setNote] = useState(null);
  const [edit, setEdit] = useState(false);

  useEffect(() => {
    handleListen();
  }, [isListening]);

  const handleListen = () => {
    if (isListening) {
      mic.start();
      mic.onend = () => {
        console.log("continue..");
        mic.start();
      };
    } else {
      mic.stop();
      mic.onend = () => {
        console.log("Stopped Mic on Click");
      };
    }
    mic.onstart = () => {
      console.log("Mics on");
    };

    mic.onresult = (event) => {
      const transcript = Array.from(event.results)
        .map((result) => result[0])
        .map((result) => result.transcript)
        .join("");
      console.log(transcript);
      setNote(transcript);
      setStudentConcern(transcript);
      mic.onerror = (event) => {
        console.log(event.error);
      };
    };
  };

  const [card, setCard] = useState(false);

  const [studentConcern, setStudentConcern] = useState("");
  const handleStudentConcernSubmit = (e) => {
    e.preventDefault();
    setCard(true);
    // hit THE API
    let data = {};
    data = {
      user_id: userId,
      extra_information: {
        session: id,
        area_of_concern: studentConcern,
      },
    };

    token_api
      .post(
        `/counseling/add/student/update_student_profile/?user=${userId}`,
        data
      )
      .then((response) => {
        console.log("CheckingResponseafterpost", response.data.data);
        // setStudentDream(response?.data?.data?.dream)
      })
      .catch((err) => {
        console.log(err);
      });
    setEdit(true);

    console.log("areaOfConcern", data);
  };

  useEffect(() => {
    if(area_concern) {
      setStudentConcern(area_concern);

      console.log(area_concern, "wkeif9d8f723uij4ed");
    }
    
  }, [area_concern]);

  const toggleEdit = () => {
    setCard(false);
    setEdit(false);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    // DISPATCH

    setStudentConcern(value);
  };
  return (
    <>
      <div className={styles.cardContainer}>
        <div className={styles.editStyle}>
          <span className={styles.font20}>Area of concern</span>
          {isListening == false ? (
            <MicOffIcon
              sx={{ color: "#f71302" }}
              onClick={() => setIsListening((prevState) => !prevState)}
            />
          ) : (
            <MicIcon
              sx={{ color: "#02f733" }}
              onClick={() => setIsListening((prevState) => !prevState)}
            />
          )}
          {/* <Button
            size="small"
            onClick={() => setIsListening((prevState) => !prevState)}
          >
            {" "}
            Start/Stop Mic
          </Button> */}
          {edit && (
            <div style={{ display: "flex" }}>
              {edit && (
                <span style={{ cursor: "Pointer" }} onClick={toggleEdit}>
                  Edit
                </span>
              )}
            </div>
          )}
        </div>
        {card == false ? (
          <>
            <div>
              <form onSubmit={handleStudentConcernSubmit}>
                <TextField
                  fullWidth
                  //   id="outlined-required"
                  //   label="Required"

                  onChange={handleChange}
                  name="concern"
                  value={studentConcern}
                  multiline
                  required
                  rows={4}
                />
                <div style={{textAlign:"right"}}>
                <Button
                  style={{
                    // position: "relative",
                    // left: "82%",
                    marginTop: "10px",
                  }}
                  size="small"
                  variant="contained"
                  type="submit"
                >
                  Save
                </Button>
                </div>
              </form>
            </div>
          </>
        ) : (
          <>
            <div className={styles.showCard}>
              {studentConcern && studentConcern}
            </div>
          </>
        )}

        {/* show card */}
      </div>
    </>
  );
};

export default CustomConcern;
